import 'filepond-polyfill'
import React, { Component } from 'react';
import { authHeader, authHeaderJson } from '../auth-header';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {
    Paper, LinearProgress, AppBar, Table, TableBody, TableCell, TableHead,
    TableRow, Toolbar, IconButton, Button, FormGroup, TextField, FormLabel,
    Divider
} from '@material-ui/core';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';

import IconRefresh from '@material-ui/icons/Refresh';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import PlusIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import IconDelete from '@material-ui/icons/DeleteForever';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

const styles = theme => ({
    header: {
        padding: theme.spacing.unit * 2,
    },
    results: {
        margin: theme.spacing.unit * 2,
    },
    errors: {
        padding: theme.spacing.unit * 2,
        color: theme.palette.error.main,
    },
    errorButton: {
        color: theme.palette.error.main,
    },
    pond: {
        height: 100,
    },
    spaceL: { marginLeft: theme.spacing.unit },
    grow: {
        flexGrow: 1,
    },
    numberField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 100,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
});


class UpdateDB extends Component {
    static displayName = UpdateDB.name;

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            step: 0,
            stateData: { progress: 0, finished: false, success: true },
            chovy: null,
            errors: [],
            dialogOpen: false,
            krokr: '',
            podn: '',
            chov: '',
            saveDB: false,
            notText: '',
            errMsg: '',
            lstMsgs: [],
            users: [],
            listData: [],
            user: '',
            requestId: 0,
            reqData: {user:'', text:''},
        };
        this.fileUploaded = this.fileUploaded.bind(this);
        this.handleSave = this.handleSave.bind(this);

    }
    componentDidMount() {
        this.loadReqs();
    }
    loadReqs() {
        fetch('api/ModifyReproDbPssr/GetRequests', { headers: authHeader() })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                this.setState({ listData: data });
            })
            .catch(err => {
                console.error(err);
            });
    }


    getDateTime(datstr) {
        if (datstr === null) return '';
        var dat = new Date(datstr);
        var yyyy = dat.getFullYear();
        var mm = dat.getMonth() < 9 ? "0" + (dat.getMonth() + 1) : (dat.getMonth() + 1); // getMonth() is zero-based
        var dd = dat.getDate() < 10 ? "0" + dat.getDate() : dat.getDate();
        var hh = dat.getHours() < 10 ? "0" + dat.getHours() : dat.getHours();
        var min = dat.getMinutes() < 10 ? "0" + dat.getMinutes() : dat.getMinutes();
        var ss = dat.getSeconds() < 10 ? "0" + dat.getSeconds() : dat.getSeconds();
        return "" + dd + "." + mm + "." + yyyy + " " + hh + ":" + min + ":" + ss;
    };
    handleClose() {
        this.setState({ dialogOpen: false });
    }
    handleSave() {
        this.setState({ step: 3 }, () => {
            fetch('api/ModifyReproDbPssr/GetDB', { headers: authHeaderJson(), method: 'post', body: JSON.stringify({ id: this.state.id, reqId: this.state.requestId }) })
                .then(res => res.json())
                .then(data => {
                    if (data.success)
                        this.checkStatus(this.state.id);
                    else {
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        });
    }


    validate(file, type) {
        return new Promise((resolve, reject) => {
            let ext = file.name.split('.').pop().toLowerCase()
            if (ext === "sql") {
                resolve('application/sql')
            } else {
                reject('Neplatný typ súboru');
            }
        })
    }
    getChov() {
        fetch('api/ModifyReproDbPssr/' + this.state.id, { headers: authHeader() })
            .then(response => response.json())
            .then(data => {
                //         console.log(data);
                this.setState({ chovy: data });
            })
            .catch(err => {

            });
    }

    addChovApi() {

        fetch('api/ModifyReproDbPssr/AddNew', {
            headers: authHeaderJson(), method: 'post', body: JSON.stringify({
                krokr: this.state.krokr,
                podn: this.state.podn,
                chov: this.state.chov,
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.success) {
                    this.checkStatus(this.state.id);
                }
                else {
                    this.setState({ saveDB: false, errMsg: data.message });
                }
            })
            .catch(err => {
                console.error(err);
                this.setState({ saveDB: false });
                //                this.setState({ loading: false });
            });
    }


    fileUploaded(id) {
        //      console.log(response);
        this.setState({ requestId: id }, () => {
            fetch('api/ModifyReproDbPssr/LoadDb/' + id, { headers: authHeader() })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        this.setState({ step: 1, id: data.id, reqData:data }, () => this.checkStatus(data.id));
                    }
                    else {
                        this.setState({ step: 1, stateData: { finished: true, success: false, message: data.message } });
                    }
                });
        });
    }
    checkStatus(taskId) {
        fetch('api/ModifyReproDbPssr/GetStatus?id=' + taskId, { headers: authHeader() })
            .then(response => response.json())
            .then(data => {
                //         console.log(data);
                this.setState({ stateData: data });
                if (!data.finished)
                    setTimeout(function () { this.checkStatus(taskId) }.bind(this), 2000);
                else {
                    if (data.success) {
                        if (this.state.step === 1) {
                            this.setState({ step: 2 }, () => this.getChov());
                        }
                        else if (this.state.step === 2) {
                            var msgs = this.state.lstMsgs;
                            msgs.push(data.message);
                            this.setState({ saveDB: false, dialogOpen: false, errMsg: '', lstMsgs: msgs }, () => this.getChov());
                        }
                        else if (this.state.step === 3) {
                            this.setState({ step: 0 }, () => this.loadReqs());
                        }
                    }

                }
            })
            .catch(err => {
                setTimeout(function () { this.checkStatus(taskId) }.bind(this), 5000);
            });

    }
    render() {
        const { classes } = this.props;

        return (
            <Paper className={classes.header}>

                <Stepper orientation="vertical" activeStep={this.state.step}>
                    <Step>
                        <StepLabel>Výber žiadosti</StepLabel>
                        <StepContent>
                            <Table padding="none">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Deň</TableCell>
                                        <TableCell>Požiadal</TableCell>
                                        <TableCell>Stav</TableCell>
                                        <TableCell></TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.listData.map(not =>
                                        <TableRow key={not.id} hover>
                                            <TableCell>{this.getDateTime(not.requestTime)}</TableCell>
                                            <TableCell>{not.requestUser}</TableCell>
                                            <TableCell>{not.fileSize > 0 ? "Vybavená" : "-"}</TableCell>
                                            <TableCell>
                                                <Button color="secondary" variant="outlined" onClick={event => this.fileUploaded(not.id)}>Otvoriť žiadosť</Button >
                                                <IconButton onClick={event => this.delRow(event, not.id, this.getDateTime(not.requestTime))}><IconDelete /></IconButton >
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </StepContent>
                    </Step>
                    <Step>
                        <StepLabel>Import databázy</StepLabel>
                        <StepContent>
                            <Typography variant="body2" component="div">Prebieha import databázy</Typography>
                            {this.state.stateData &&
                                <LinearProgress variant="determinate" value={this.state.stateData.progress} />
                            }
                        </StepContent>
                        {this.state.stateData.finished && !this.state.stateData.success && <StepLabel error={true}>Problém pri importe: {this.state.stateData.message}</StepLabel>}
                    </Step>
                    <Step>
                        <StepLabel>Úprava databázy</StepLabel>
                        <StepContent>
                            <AppBar position="static">
                                <Toolbar>
                                    <Typography className={classes.grow} variant="h6" color="inherit">Prehľad chovov</Typography>
                                    <IconButton color="inherit" onClick={(e) => this.setState({ dialogOpen: true })} >
                                        <PlusIcon />
                                    </IconButton>

                                    <IconButton color="inherit" onClick={this.getChov.bind(this)}>
                                        <IconRefresh />
                                    </IconButton>
                                    <Button variant="contained" color="secondary" onClick={this.handleSave} disabled={this.state.saveDB}>Export databázy</Button>
                                </Toolbar>
                            </AppBar>
                            <Typography variant="subheading" component="div">Žiadosť vložil(a): {this.state.reqData.user}</Typography>
                            <Typography variant="subheading" component="div">{this.state.reqData.text}</Typography>
                            <Table padding="none">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>KrOkr</TableCell>
                                        <TableCell>Podnik</TableCell>
                                        <TableCell>Chov</TableCell>
                                        <TableCell>Názov</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.chovy && this.state.chovy.map((x, idx) =>
                                        <TableRow key={idx}>
                                            <TableCell>{x.krok}</TableCell>
                                            <TableCell>{x.podn}</TableCell>
                                            <TableCell>{x.chma}</TableCell>
                                            <TableCell>{x.chov_nazov}</TableCell>
                                        </TableRow>)
                                    }
                                </TableBody>
                            </Table>
                        </StepContent>
                    </Step>
                    <Step>
                        <StepLabel>Export databázy</StepLabel>
                        <StepContent>
                            {this.state.lstMsgs.map((x, idx) => <Typography variant="body1" component="div" key={idx}>{x}</Typography>)}
                            <Typography variant="body2" component="div">Prebieha export databázy</Typography>
                            {this.state.stateData &&
                                <LinearProgress variant="determinate" value={this.state.stateData.progress} />
                            }
                        </StepContent>
                        {this.state.stateData.finished && !this.state.stateData.success && <StepLabel error={true}>Problém pri importe: {this.state.stateData.message}</StepLabel>}
                    </Step>
                </Stepper>

                <Dialog
                    open={this.state.dialogOpen}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                    scroll="paper"
                    maxWidth="lg"
                >
                    <DialogTitle id="responsive-dialog-title">{"Pridať chov"}</DialogTitle>
                    <DialogContent>
                        {this.state.errors.length > 0 && <FormLabel error>Formulár obsahuje chyby, nie je možné ho odoslať</FormLabel>}
                        {this.state.errMsg.length > 0 && <FormLabel error>{this.state.errMsg}</FormLabel>}

                        <FormGroup row>
                            <TextField error={this.state.errors.some(x => x === 'krokr')}
                                label="KrOkr"
                                className={classes.numberField}
                                required name="krokr"
                                margin="normal"
                                value={this.state.krokr}
                                onChange={this.handleInputChange.bind(this)} autoFocus
                            />
                            <TextField error={this.state.errors.some(x => x === 'podn')}
                                label="Podnik"
                                className={classes.numberField}
                                type="number"
                                margin="normal"
                                required name="podn"
                                value={this.state.podn}
                                onChange={this.handleInputChange.bind(this)}
                            />
                            <TextField error={this.state.errors.some(x => x === 'chov')}
                                label="Chov"
                                className={classes.numberField}
                                type="number"
                                margin="normal"
                                required name="chov"
                                value={this.state.chov}
                                onChange={this.handleInputChange.bind(this)}
                            />
                        </FormGroup>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={e => this.addChov()} color="secondary" autoFocus variant="outlined"><SaveIcon />Pridať</Button>
                        <Button onClick={e => this.handleClose()} color="secondary" variant="outlined"><CancelIcon />Zrušiť</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.saveDB}>
                    <DialogTitle id="responsive-dialog-title">{"Spracovanie údajov"}</DialogTitle>
                    <DialogContent>
                        <LinearProgress />
                        <Typography variant="subtitle1" gutterBottom>{this.state.notText}</Typography>
                        <Divider />
                        {this.state.step === 2 && <Typography variant="subtitle1" gutterBottom>Stav spracovania: {this.state.stateData.progress} položiek</Typography>}
                    </DialogContent>
                </Dialog>
            </Paper>
        );
    }
    addChov() {
        let errs = [];
        if (this.state.krokr.length !== 3 || !this.isNumeric(this.state.krokr)) errs.push("krokr");
        if (this.state.podn.length !== 3 || !this.isNumeric(this.state.podn)) errs.push("podn");
        if (this.state.chov.length !== 3 || !this.isNumeric(this.state.chov)) errs.push("chov");
        this.setState({ errors: errs });
        if (errs.length > 0)
            return;
        this.setState({
            notText: 'Prebieha doplnenie údajov chovu ' + this.state.krokr + '-' + this.state.podn + '-' + this.state.chov + ' do databázy, ktoré može trvať niekoľko sekúnd. Tento oznam bude automaticky odstánený po ukončení úlohy.',
            saveDB: true
        }, () => this.addChovApi());
    }
    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    handleInputChange({ target }) {
        this.setState({ [target.name]: target.value });
    }
}
UpdateDB.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UpdateDB);



// WEBPACK FOOTER //
// ./src/components/pssr/UpdateDB.jsx